<template>
  <SidebarComponent /> <!-- Aggiungi il componente sidebar qui -->
  <div class="dashboard-layout">
    <div class="content-container"> <!-- Contenitore per il contenuto principale -->
      <div class="card-container">
        <div class="titolo-card">
          <h1>Riepilogo ordine</h1>
        </div>

        <div class="card-black">
          <h2>Riepilogo Ordine</h2>

          <ul v-if="orderDetails && orderDetails.products">
            <li v-for="product in orderDetails.products" :key="product.id">
              <h3>{{ product.name }}</h3>
              <p>Prezzo: €{{ product.price }}</p>
              <p>Descrizione: {{ product.description }}</p>
            </li>
          </ul>

          <p>Totale: €{{ calculateTotal }}</p>

          <!-- Selettore per il metodo di pagamento -->
          <div class="payment-method">
            <label for="paymentMethod">Metodo di Pagamento:</label>
            <select id="paymentMethod" v-model="selectedPaymentMethod">
              <option value="Carta">Carta</option>
              <option value="Contanti">Contanti</option>
              <option value="Bonifico">Bonifico</option>
            </select>
          </div>

          <div class="user-search">
    <input v-model="searchEmail" placeholder="Cerca utente per email">
    <button class="staff-button-neutral" @click="searchUser">Cerca</button>

    <div v-if="searchedUser">
      <p>Nome: {{ searchedUser.name }}</p>
      <p>Email: {{ searchedUser.email }}</p>
      <!-- Altri dettagli dell'utente -->
    </div>
    <div class="save-order-button">
    <button class="staff-button-positive" @click="saveOrder">Assegna e Salva Ordine</button>
  </div>
  </div>         
  
  <!-- ... -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'; // Assicurati di importare 'ref' qui
import { useStore } from 'vuex';
import { getFirestore, collection, query, where, getDocs, addDoc } from 'firebase/firestore';
import SidebarComponent from '../SidebarComponent'; // Assicurati di avere il percorso corretto

export default {
  name: 'OrderSummary',
  components: {
    SidebarComponent,
  },
  setup() {
    const store = useStore();
    const selectedPaymentMethod = ref('Carta'); // Metodo di pagamento preselezionato
    const searchEmail = ref('');
    const searchedUser = ref(null);
    const db = getFirestore();


    const saveOrder = async () => {
      if (!searchedUser.value) {
        alert('Nessun utente selezionato per l\'ordine.');
        return;
      }

      const orderDetails = {
        ...store.state.orderDetails,
        userId: searchedUser.value.uid,
        userEmail: searchedUser.value.email,
        paymentMethod: selectedPaymentMethod.value, // Metodo di pagamento selezionato

      };

      try {
        await addDoc(collection(db, "orders"), orderDetails);
        alert('Ordine salvato con successo.');
      } catch (error) {
        console.error('Errore durante il salvataggio dell\'ordine:', error);
        alert('Errore durante il salvataggio dell\'ordine.');
      }
    };

    const searchUser = async () => {
      const usersCollection = collection(db, "users");
      const q = query(usersCollection, where("email", "==", searchEmail.value));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        searchedUser.value = querySnapshot.docs[0].data();
      } else {
        searchedUser.value = null;
        alert('Utente non trovato.');
      }
    };

    const orderDetails = computed(() => store.getters.getOrderDetails);
console.log('Dati ricevuti da store:', orderDetails.value);

const calculateTotal = computed(() => {
  return orderDetails.value ? orderDetails.value.products.reduce((total, product) => total + product.price, 0) : 0;
});


    return {
      orderDetails,
      calculateTotal,
      selectedPaymentMethod,
      searchEmail,
      searchedUser,
      searchUser,
      saveOrder,
    };
  },
};
</script>

<style scoped>
.card-black {
  background-color: #111111;
  padding: 20px;
  border-radius: 23px;
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.5);
  max-width: 1500px;
  margin: 20px auto;
  background-color: rgb(36, 36, 36);
}

.card-black h2 {
  margin-bottom: 20px;
  font-size: 1.5em;
  color: #ebebeb;
}

.card-black ul {
  list-style-type: none;
  padding: 0;
}

.card-black li {
  border-bottom: 1px solid #6e6e6e;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.card-black li:last-child {
  border-bottom: none;
}

.card-black p {
  margin: 5px 0;
  color: #bbb;
}

.payment-method {
  margin-top: 20px;
  padding: 10px 0;
}

.payment-method label {
  margin-right: 10px;
  color: #ccc;
}

.payment-method select {
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #6e6e6e;
  background-color: rgba(162, 162, 162, 0.3);
  color: white;
  cursor: pointer;
}

.user-search {
  margin-top: 20px;
}

.user-search input {
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid #6e6e6e;
  color: #fff;
  background-color: rgba(162, 162, 162, 0.3);
}

.user-search button {
  padding: 8px 12px;
  margin-left: 10px;
  background-color: rgba(162, 162, 162, 0.3);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.user-search button:hover {
  background-color: #181818;
}

.save-order-button {
  margin-top: 20px;
}

.save-order-button button {
  padding: 10px 20px;
  background-color: rgba(162, 162, 162, 0.3);
  color: white;
  border: none;
  border-radius: 24px;
  cursor: pointer;
}

.save-order-button button:hover {
  background-color: #181818;
}
</style>

